
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/components/ui/use-toast";
import { useState } from "react";
import type { Book } from "../types";

export function useBookActions(onSuccess?: () => void) {
  const [loading, setLoading] = useState(false);

  const deleteBook = async (id: string) => {
    if (window.confirm("Are you sure you want to delete this book?")) {
      try {
        setLoading(true);
        const { error } = await supabase.from("books").delete().eq("id", id);

        if (error) {
          throw error;
        }

        toast({
          title: "Success",
          description: "Book deleted successfully",
        });
        
        if (onSuccess) {
          onSuccess();
        }
      } catch (error) {
        console.error("Error deleting book:", error);
        toast({
          title: "Error",
          description: "Failed to delete book",
          variant: "destructive",
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return {
    loading,
    deleteBook,
  };
}
